export default __webpack_public_path__ + "static/media/client4.9ded096a.png";